<footer class="w-full bg-gray-800 text-white text-xs sm:text-sm py-5 px-6">
  <div class="max-w-screen-xl mx-auto flex flex-col gap-5 lg:flex-row lg:items-start lg:gap-8">

    <!-- Col 1: Logo -->
    <div class="flex-shrink-0">
      <img [src]="cfg.project.logo" [alt]="cfg.project.name" class="h-14 w-auto object-contain" />
    </div>

    <!-- Col 2: Nombre municipalidad -->
    <div class="flex flex-col gap-1 leading-tight lg:flex-shrink-0">
      <span class="font-bold text-base sm:text-lg tracking-wide lg:whitespace-nowrap">{{ cfg.project.officialName }}</span>
      <span class="opacity-60 text-xs">{{ cfg.project.description }}</span>
    </div>

    <!-- Separador: línea horizontal en mobile/tablet, barra vertical en desktop -->
    <hr class="border-gray-600 lg:hidden" />
    <div class="hidden lg:block w-px bg-gray-600 self-stretch"></div>

    <!-- Cols 3 y 4: apiladas en mobile, lado a lado en tablet, como columnas directas en desktop -->
    <div class="flex flex-col gap-5 sm:flex-row sm:gap-8 lg:contents">

      <!-- Col 3: Información de contacto -->
      <div class="flex-1 flex flex-col gap-1.5 leading-snug">
        <span class="font-semibold text-xs uppercase tracking-widest opacity-60 mb-0.5">Información de contacto Municipalidad</span>
        <a [href]="'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(cfg.project.address)"
           target="_blank" rel="noopener noreferrer"
           class="flex items-start gap-2 hover:opacity-70 transition-opacity">
          <i class="pi pi-map-marker opacity-60 text-xs flex-shrink-0 mt-0.5"></i>
          <span>{{ cfg.project.address }}</span>
        </a>
        <div class="flex items-center gap-2">
          <i class="pi pi-phone opacity-60 text-xs flex-shrink-0"></i>
          <span class="flex flex-wrap gap-x-2 gap-y-0.5">
            @for (phone of cfg.project.phone; track phone; let last = $last) {
              <a [href]="'tel:' + phone" class="hover:opacity-70 transition-opacity">{{ phone }}</a>
              @if (!last) { <span class="opacity-40">·</span> }
            }
          </span>
        </div>
        <a [href]="'https://' + cfg.project.website"
           target="_blank" rel="noopener noreferrer"
           class="flex items-center gap-2 hover:opacity-70 transition-opacity">
          <i class="pi pi-globe opacity-60 text-xs flex-shrink-0"></i>
          <span>{{ cfg.project.website }}</span>
        </a>
      </div>

      <!-- Separador: visible entre col3 y col4 desde tablet en adelante -->
      <div class="hidden sm:block w-px bg-gray-600 self-stretch"></div>

      <!-- Col 4: Soporte SmartDOM -->
      <div class="flex-shrink-0 flex flex-col gap-1.5 leading-snug">
        <span class="font-semibold text-xs uppercase tracking-widest opacity-60 mb-0.5">Soporte {{ cfg.smartDOM.name }}</span>
        <a [href]="'mailto:' + cfg.project.support"
           class="flex items-center gap-2 hover:opacity-70 transition-opacity">
          <i class="pi pi-headphones opacity-60 text-xs flex-shrink-0"></i>
          <span>{{ cfg.project.support }}</span>
        </a>
      </div>

    </div>

  </div>
</footer>
